const branding = {
  ENERGIC: 'energic',
  VOLTIE: 'voltie',
};

const allStatus = {
  REJECTED: 'rejected',
  PENDING: 'pending',
  FINISHED: 'finished',
  INPROGRESS: 'inProgress',
  ACCEPTED: 'Accepted',
  AVAILABLE: 'Available',
  UNAVAILABLE: 'Unavailable',
  PREPARING: 'Preparing',
  FINISHING: 'Finishing',
  FAULTED: 'Faulted',
  CHARGING: 'Charging',
};

export { branding, allStatus };
